import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import stylePlugins from './plugins';
import { colorStyleNames } from './style-names';
var pluginCount = stylePlugins.length;
export function parsePluginStyles(initialStyles, componentPlugin, theme) {
  if (initialStyles === void 0) {
    initialStyles = {};
  }

  var nextStyles = _objectSpread({}, initialStyles);

  if (componentPlugin) {
    nextStyles = componentPlugin.getStyles(nextStyles, theme);
  }

  for (var index = 0; index < pluginCount; index++) {
    var stylePlugin = stylePlugins[index];
    nextStyles = stylePlugin(nextStyles, theme);
  }

  if (nextStyles.css) {
    nextStyles = _objectSpread(_objectSpread({}, nextStyles), parseCssStyles(nextStyles.css, componentPlugin, theme));
    delete nextStyles.css;
  }

  return nextStyles;
}
export function parseStyles(style, plugin, theme) {
  var parsedStyle = {};

  for (var prop in style) {
    var value = style[prop];
    parsedStyle[prop] = colorStyleNames.indexOf(prop) === -1 && typeof value === 'object' ? parseStyles(value, plugin, theme) : value;
  }

  return parsePluginStyles(parsedStyle, plugin, theme);
}
export function parseCssStyles(style, plugin, theme) {
  return style ? style.constructor === Array ? style.reduce(function (collection, styles) {
    return _objectSpread(_objectSpread({}, collection), parseStyles(styles, plugin, theme));
  }, {}) : parseStyles(style, plugin, theme) : null;
}